import React, { ReactElement } from 'react';
import { Img, Txt, Div } from 'Components/GenericView';
import { AdlServices } from "Components/AdlServices";
import { InputField } from "Components/InputField";
import { COMPANIONSHIP, MEDICAL_ESCORT } from 'DataConstants';

export type ADLServicesSectionPropType = {
  selectedAdls: Array<string>;
  goneIfReadOnly: string;
  hasError: string | undefined;
  adlList: any;
  mealRequirements: any;
  isReadOnly: boolean | undefined;
  dontAnimate: boolean | undefined;
  onAdlChange: (requestedServices: any[], mealRequirements: any[]) => void;
  onTextChange: (_e: any, t: string) => void;
  companionShipDescription: string | undefined;
  switchViewToMedicalEscortDetails: () => void;
  medicalEscortDetails: string | undefined;
  visitHasMedicalEscortDetails: any;
}

const ADLServicesSection = (props: ADLServicesSectionPropType) => {
  const {
    selectedAdls,
    goneIfReadOnly,
    hasError,
    adlList,
    mealRequirements,
    isReadOnly,
    dontAnimate,
    onAdlChange,
    onTextChange,
    companionShipDescription,
    switchViewToMedicalEscortDetails,
    medicalEscortDetails,
    visitHasMedicalEscortDetails
  } = props;

  const showMedicalEscortDetails = visitHasMedicalEscortDetails && selectedAdls.includes(MEDICAL_ESCORT);

  const _onClickMedicalEscortsDetails = (event: any) => {
    if (!isReadOnly) {
      switchViewToMedicalEscortDetails();
    } else {
      event.currentTarget.blur()
    }
  }

  const _renderCompanionshipDescriptionField = (): ReactElement | null => {
    if (selectedAdls.includes(COMPANIONSHIP)) {
      return (<>
        <Txt m mv={6} ml={6}>
          Companionship Description
        </Txt>
        <InputField
          type="text"
          className="nvd-specific-instructions"
          width="100%"
          maxWidth="100%"
          dontAnimate={dontAnimate}
          multiLine
          noAutoSelect
          lineHeight={16}
          maxLines={6}
          blurOnTabKey
          placeholder="e.g. She enjoys music, dancing and calligraphy"
          readOnly={isReadOnly}
          onTextChange={(_e: any, text: string) => onTextChange(_e, text)}
          text={companionShipDescription}
        />
        <Div height={7} />
      </>)
    }

    return null;
  }

  const _renderMedicalEscortDetailsSection = (): ReactElement | null => {
    if (showMedicalEscortDetails) {
      return (
        <Div
          className="nvd-me-desc v"
          onClick={(e: any) => _onClickMedicalEscortsDetails(e)}
        >
          <Txt m mv={6} ml={6}>
            Medical Escort Details
          </Txt>
          <span className="nvd-me-details">
            {medicalEscortDetails}
          </span>
          <Div height={7} />
        </Div>
      )
    };

    return null;
  }

  return <>
    <div
      className={`nvd-row h${!selectedAdls[0] ? goneIfReadOnly : ""}`}
      has-error={hasError}
    >
      <Img src="/services_green.png" className="nvd-icon" />
      <i className="nvd-star">*</i>

      <div className="v grow">
        {/* Adl Services */}
        <div className="h grow">
          <Txt className="nvd-text no-shrink" width={86 + 23 + 18}>
            ADL Services
          </Txt>

          <span className="nvd-error nvd-srv-err nvd-err-long">
            <img
              alt="error"
              src="/warning_red.png"
              className="nvd-error-icon"
            />
            Please select some services
          </span>

          <AdlServices
            className="nvd-cont nvd-services"
            tdClassName="nvd-service"
            tdInputClassName="nvd-add-adl"
            adlList={adlList}
            requested_services={selectedAdls}
            meal_requirements={mealRequirements}
            readOnly={isReadOnly}
            hidden={isReadOnly}
            dontAnimate={dontAnimate}
            onAdlChange={onAdlChange}
          >
            {_renderCompanionshipDescriptionField()}
            {_renderMedicalEscortDetailsSection()}
          </AdlServices>
        </div>
      </div>
    </div>
  </>
}

export default ADLServicesSection;